import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface InflowInfiltrationWarningModalProps {
	visible: boolean;
	onClose: () => void;
}

function InflowInfiltrationWarningModal({
	visible,
	onClose,
}: InflowInfiltrationWarningModalProps) {
	return (
		<Modal
			open={visible}
			onCancel={onClose}
			onOk={onClose}
			title={
				<div className="flex items-center gap-2">
					<ExclamationCircleOutlined className="text-orange-500 text-xl" />
					<span>Wet Weather Stress Lens Unavailable</span>
				</div>
			}
			okText="OK"
			cancelButtonProps={{ style: { display: 'none' } }}
			centered
			width={500}
		>
			<div className="py-4">
				<p className="text-base text-gray-700 m-0">
					<strong>Wet Weather Stress lens</strong> is only available for{' '}
					<strong>wastewater networks</strong> and for periods of time that are{' '}
					<strong>less than 1 week</strong>.
				</p>
				
			</div>
		</Modal>
	);
}

export default InflowInfiltrationWarningModal;
